import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginationDropdownComponent } from './paginations/pagination-dropdown/pagination-dropdown.component';
import { PaginationSummaryComponent } from './paginations/pagination-summary/pagination-summary.component';
import { PaginationControlsComponent } from './paginations/pagination-controls/pagination-controls.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@ngneat/transloco';


@NgModule({
  
  declarations: [PaginationControlsComponent, PaginationDropdownComponent, PaginationSummaryComponent],
  imports: [CommonModule, NgxPaginationModule, FormsModule, MatIconModule, TranslocoModule],
  exports: [PaginationControlsComponent, PaginationDropdownComponent, PaginationSummaryComponent]
})
export class PaginationControlsModule { }
